namespace GeniuzPOS.QRreport {
    export enum doctypefg {
        shortdoc = 1,
        longdoc = 2
    }
    Serenity.Decorators.registerEnumType(doctypefg, 'GeniuzPOS.QRreport.doctypefg');
}
